(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bezza-pack-selector"] && !Shopify.designMode) return;
  try {
    class BezzaPackSelectorComponent extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.handlePackChange);
      const selectedPack = this.querySelector('.bezza-pack-card__radio:checked');
      if (selectedPack instanceof HTMLInputElement) {
        this.updateBuyNowButton(selectedPack.value);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handlePackChange);
    }

    handlePackChange = (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

      const productForm = this.querySelector('product-form-component');
      const variantInput = this.querySelector('[data-bezza-selected-variant]');
      const productIdInput = this.querySelector('input[name="product-id"]');
      const addToCartComponent = this.querySelector('[data-bezza-main-add] add-to-cart-component');
      const addButton = this.querySelector('[data-bezza-main-add] button[name="add"]');
      const addButtonText = addButton?.querySelector('.add-to-cart-text__content span span');
      const available = input.dataset.available === 'true';

      if (variantInput instanceof HTMLInputElement) {
        variantInput.value = input.value;
      }

      if (productIdInput instanceof HTMLInputElement && input.dataset.productId) {
        productIdInput.value = input.dataset.productId;
      }

      if (productForm instanceof HTMLElement) {
        productForm.dataset.productId = input.dataset.productId || '';
        productForm.dataset.productUrl = input.dataset.productUrl || '';
      }

      if (addToCartComponent instanceof HTMLElement) {
        addToCartComponent.dataset.productVariantMedia = input.dataset.productMedia || '';
      }

      if (addButton instanceof HTMLButtonElement) {
        addButton.disabled = !available;
      }

      if (addButtonText instanceof HTMLElement) {
        addButtonText.textContent = available ? this.dataset.addText || '' : this.dataset.soldText || '';
      }

      this.updateBuyNowButton(input.value);
    };

    updateBuyNowButton = (variantId) => {
      this.querySelectorAll('[data-bezza-buy-now]').forEach((checkout) => {
        if (checkout instanceof HTMLElement) {
          checkout.hidden = checkout.dataset.variantId !== variantId;
        }
      });
    };
  }

  if (!customElements.get('bezza-pack-selector-component')) {
    customElements.define('bezza-pack-selector-component', BezzaPackSelectorComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
